import ConfirmEmailPage from './ConfirmEmailPage';

export default ConfirmEmailPage;
